<div class="message-card border-20" [ngStyle]="{'width': width, 'height': height}">
    <ng-template #placeholderCardMessage>
        <div class="placeholderMessage">
            <h1>{{'placeholder.message.card' | translate}}</h1>
        </div>
    </ng-template>

    <ng-container *ngTemplateOutlet="cardContent ? cardContent: placeholderCardMessage"></ng-container>
</div>